import axios from "axios";

const cleanBaseUrl = (value) => {
  if (!value) return "";
  return String(value).trim().replace(/\/+$/, "");
};

const API_BASE_URL =
  cleanBaseUrl(process.env.REACT_APP_API_URL) || `${window.location.origin}/api`;

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: { "Content-Type": "application/json", Accept: "application/json" },
});

export const getTranslationsApi = async () => {
  try {
    const res = await apiClient.get("/translations");
    return {
      success: Boolean(res?.data?.success),
      translations: res?.data?.translations || {},
      sectionLabels: res?.data?.sectionLabels || {},
      languages: res?.data?.languages || [],
    };
  } catch (error) {
    return {
      success: false,
      error: error?.response?.data?.error || error?.message || "Fehler beim Laden.",
      translations: {},
      sectionLabels: {},
      languages: [],
    };
  }
};

export const updateTranslationsApi = async (translations) => {
  try {
    const res = await apiClient.put("/translations", { translations });
    return { success: Boolean(res?.data?.success), translations: res?.data?.translations || {} };
  } catch (error) {
    return {
      success: false,
      error: error?.response?.data?.error || error?.message || "Fehler beim Speichern.",
    };
  }
};

export const resetTranslationsApi = async () => {
  try {
    const res = await apiClient.post("/translations/reset");
    return { success: Boolean(res?.data?.success), translations: res?.data?.translations || {} };
  } catch (error) {
    return {
      success: false,
      error: error?.response?.data?.error || error?.message || "Fehler beim Zurücksetzen.",
    };
  }
};
